// Define Namespaces here
// Make our auth layer more universal, move away from Next.js
//
// TODO:
// - [ ] add tracing option for PH on certain events
// - [ ] leave design open for future OAuth providers

export * from "./lib/types";
export * from "./lib/client";
export * from "./constants";

// Clients
export * from "./lib/providers/google/mod";
